export default "<div>\n  <div class=\"container\">\n    <app-header></app-header>\n    <hr>\n    <router-outlet></router-outlet>\n  </div>\n</div>"